/**
 * Windows がファイル名に使えない文字 (`\ / : * ? " < > |`)。 残すとブラウザが別の文字に
 * 置き換えたり保存に失敗したりし、 利用者が Excel で開くファイル名が意図と変わる。
 */
const FORBIDDEN_FILENAME_CHARS = /[\\/:*?"<>|]/g

/** ファイル名から Excel / Windows が使えない文字を `_` に置き換える。 */
export const toSafeFilename = (filename: string): string =>
  filename.replace(FORBIDDEN_FILENAME_CHARS, '_')

/**
 * Blob をブラウザのファイルダウンロードとして保存する。
 *
 * ファイル名の禁止文字はここで `_` に置き換える。 anchor の `download` (代入・属性) は lint
 * (`@ebalance/eslint-config` の restricted-syntax) が止めていて、 ダウンロードはすべて
 * この関数を通る (= 置き換えを呼び出し側で忘れられない)。
 */
export const downloadBlob = (filename: string, blob: Blob): void => {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = toSafeFilename(filename)
  a.click()
  URL.revokeObjectURL(url)
}
